/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { useEffect,useCallback,useContext ,useState} from "react"
import { useDispatch,useSelector } from 'react-redux'
import { Link, useLocation,useSearchParams,useParams} from 'react-router-dom'
import TopHeader from '../../../../components/TopHeader'
import TopBar from '../../../../components/TopBar'
import Table from './Components'
import GlobalContext from '../../../../components/Context/GloablContext'
import Pagination from '../../../../components/Pagination'
import Debounce from '../../../../CommonMethods/Debounce'
import Limit from '../../../../components/Limit'
import CustomOverLay from '../../../../components/CustomOverLay'
import {  useExportOrgViewMonitorListMutation, useLazyGetOrgMonitorListQuery } from '../../../../features/organizationSlice'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen'
import OrgMonitorTable from './Components'
import OrgMonitorTopBar from './Topbar'
import Emptyscreen from '../../../../components/EmptyScreen'
import ViewMonitorUsr from '../../../ManageMonitorUser/viewMonitorUser'
import ViewAdminCorporateUser from '../../../ManageAdminAndCoporateUser/ViewAdminCorporateUser'
import PatiantAdvancedSearch from '../../../ManagePatient/Component/AdvancedSearch'
import { resetPatientSearch, setPatSearchApplied } from '../../../../redux/patientSearchSlice'
import HelpGuideModal from '../../../../components/HelpGuideModal'
import { useGetHelpGuideAdminQuery } from '../../../../features/patientSlice'

export default function ManageOrgListMonitors({isCorp}) {

    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar,isAdvancedSearchOpen,setIsAdvancedSearchOpen} = useContext(GlobalContext);
    const [limit,setLimit]=useState("15")
    const dispatch=useDispatch()
    const [viewMonitorExport]=useExportOrgViewMonitorListMutation()
    const viewId=useSelector((state)=>state?.systemConfigData?.viewToUser)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const location=useLocation()
    const [searchParams, setSearchParams] = useSearchParams({});
    const [trigger, result,lastPromiseinfo] = useLazyGetOrgMonitorListQuery()
    const [emptyField,setEmptyField]=useState(false);
    const patientSearch = useSelector(state => state.patientSearchData);
    const searchApplied = useSelector((state) => state.patientSearchData.patsearchApplied);
    const userType = sessionStorage.getItem('user_type');
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
            
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });


    const {id}=useParams()
    const [orgListingState] = useState(() => location.state ?? '')


    function handleNoOfRowsClick(number) {

        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    
    }

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
    }

    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        if (key === 'search') {
            params[key] = encodeURIComponent(value);
        } else {
            params[key] = value;
        }
        if (params.search === '') delete params.search;
        setSearchParams({ ...params });
    }

    const handleDispatch = useCallback(() => {
        if (!searchParams.get('limit')) {
            handleSearchParams('limit', '15');
        }
        if (!searchParams.get('page_number')) {
            handleSearchParams('page_number', '1');
        }
        if (!searchParams.get('user_type')) {
            isCorp===undefined?handleSearchParams('user_type', 'monitor-user'):handleSearchParams('user_type', 'corporate-user')
        }
        if(!(searchParams.get('subdivision_id'))||(searchParams.get('subdivision_id')!==id)){
            handleSearchParams('subdivision_id',id)
        }

    }, [location]);

    useEffect(()=>{
        
        if(searchParams.size>=4&&searchParams.get('view')===null){
            trigger(searchParams?.toString())
        }
       
    },[searchParams])
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
  
    useEffect(() => {
        handleDispatch()
        
    }, [handleDispatch]);

    const handleSearchClose = () => {
        dispatch(resetPatientSearch()),
        setIsAdvancedSearchOpen(false) 
    }

    const handleOnSubmit = (e) => {
        e.preventDefault();
    
        let searchString = '';
    
        
        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `user_id` and `user_id_inverse` conditions
        if (patientSearch?.user_id) {
            const userIdPrefix = patientSearch.user_id_inverse ? 'ne:' : '';
            const formattedUserId = formatSearchValue(patientSearch.user_id);
            searchString += `user_id=${userIdPrefix}${encodeURIComponent(formattedUserId)};`;
        }

        // Check for `first_name` and `first_name_inverse` conditions
        if (patientSearch?.first_name) {
            const firstNamePrefix = patientSearch.first_name_inverse ? 'ne:' : '';
            const formattedFirstName = formatSearchValue(patientSearch.first_name);
            searchString += `userDetails.first_name=${firstNamePrefix}${encodeURIComponent(formattedFirstName)};`;
        }

        // Check for `middle_name` and `middle_name_inverse` conditions
        if (patientSearch?.middle_name) {
            const middleNamePrefix = patientSearch.middle_name_inverse ? 'ne:' : '';
            const formattedMiddleName = formatSearchValue(patientSearch?.middle_name);
            searchString += `userDetails.middle_name=${middleNamePrefix}${encodeURIComponent(formattedMiddleName)};`;
        }

        // Check for `last_name` and `last_name_inverse` conditions
        if (patientSearch?.last_name) {
            const lastNamePrefix = patientSearch.last_name_inverse ? 'ne:' : '';
            const formattedLastName = formatSearchValue(patientSearch?.last_name);
            searchString += `userDetails.last_name=${lastNamePrefix}${encodeURIComponent(formattedLastName)};`;
        }

        // Check for `user_name` and `user_name_inverse` conditions
        if (patientSearch?.user_name || patientSearch.user_name_domain) {
            const userNamePrefix = patientSearch.user_name_inverse ? 'ne:' : '';
            const userName = formatSearchValue(patientSearch.user_name || '');
            const userNameDomain = formatSearchValue(patientSearch.user_name_domain || '');
            searchString += `userDetails.user_name=${userNamePrefix}${encodeURIComponent(userName)}@${encodeURIComponent(userNameDomain)};`;
        }


        // Handle `status` with optional inverse condition
        if (Array.isArray(patientSearch.status)) {
            const userStsPrefix = patientSearch.status_inverse ? 'ne:' : ''; 
            patientSearch.status.forEach(type => {
                searchString += `userDetails.status=${userStsPrefix}${encodeURIComponent(type)};`;
            });
        }

        // Remove trailing ';' if present
        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;
        
        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: patientSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            // sort: currentParams.sort || 'created_at+desc', // Keep sort or set default
            limit: currentParams.limit || '15', // Keep limit or set default
        };
    
        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;
    
        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        dispatch(setPatSearchApplied());
    };
    

    useEffect(() => {
        // If search was not applied, reset the search fields on page load
        if (!searchApplied) {
            dispatch(resetPatientSearch());
        }
    }, [dispatch, searchApplied]);

    useEffect(() => {
        if(isCorp===undefined){
            setQueryParamsadmin('type=admin-org-list-monitor-users');
        }else{
            setQueryParamsadmin('type=admin-org-list-corporate-users');
        }
    }, [userType]);
            
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    return (
        <>
            {searchParams?.get('view')!==null?(isCorp===undefined?<ViewMonitorUsr isOrganization={true} monitor_id={searchParams?.get('view')}/>:<ViewAdminCorporateUser isOrganization={true} corp_id={searchParams?.get('view')}/>):<div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Organizations"}/>
                {((result?.isFetching&&result?.status!=="fulfilled"&&result?.status!=="rejected")||(result?.data===undefined&&result?.status!=="fulfilled"&&result?.status!=="rejected"))?<CustomOverLay Active text={isCorp===undefined?`Loading Monitor List...`:'Loading Corporate List'} classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>: <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                    <div className="px-6">
                        <div className='flex items-center justify-between mb-3.5'>
                            <div className='flex items-center'>
                                <Link to="/manage-organizations" state={orgListingState}>
                                    <h1 className="text-sm font-normal text-[#52555D]" onClick={handleSearchClose}>List of Organizations</h1>
                                </Link>
                                <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        
                                {viewId!==""&&<>
                                    <Link to={`/manage-organizations/${viewId}`}>
                                        <h1 className="text-sm font-normal text-[#52555D]" onClick={handleSearchClose}>View Organization</h1>
                                    </Link>
                                    <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                </>} 
                                <h1 className="text-sm font-normal text-[#008586]">{isCorp===undefined?'List of Monitor Users':'List of Corporate Users'}</h1>
                            </div>
                            {
                                userType !=='super-admin' &&
                                <span   onClick={() => setHelpGuideModel(true)} className='ml-2 cursor-pointer min-w-max'>
                                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                </span> 
                            }
                        </div>
                        <OrgMonitorTopBar
                            path={`/manage-organizations/${viewId}`}
                            pathPlaceholder={'Go back to View Organization'}
                            pathState={orgListingState}
                            data={result?.data}
                            isCorp={isCorp}
                            isExport={true}
                            SearchInput={((result?.data?.length===0 &&searchParams.get("search")===null) || result?.data===undefined) ? false : true}
                            exportCols={['ID','Username','First Name','Last Name','Status']}                            
                            isColumnSelect={isColumnSelect}
                            setIsColumnSelect={setIsColumnSelect}
                            exportMonitorExport={viewMonitorExport}
                            isIdexport={true}
                            handleSearchClose={handleSearchClose}
                        />
                    </div>
                    {(result?.data!==undefined && result?.data?.data?.length > 0 ) ? <>   
                        <div className="px-6">
                            <OrgMonitorTable
                                pageNumber={Number(searchParams.get('page_number')) || 1}
                                List={result?.data}
                                handleSearchParams={handleSearchParams}
                                handleSearchClose={handleSearchClose}

                            />
                        </div>
                        {result?.data?.total_count>=15&&<div className="w-[100%] px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC]">
                            <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(result?.data?.total_count))}</p>
                            <div className="flex items-center pr-[3%]">
                                <Limit
                                    limit={limit}
                                    setLimit={setLimit}
                                    handleNoOfRowsClick={handleNoOfRowsClick}
                                    isColumnSelect={isColumnSelect}
                                />
                        
                                <Pagination
                                    TotalCount={parseInt(result?.data?.total_count)}
                                    totalPageNumber={Math.ceil(parseInt(result?.data?.total_count)/parseInt(searchParams?.get("limit")))}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                    // limit={Number(searchParams.get('limit'))}
                                    limit={parseInt(limit)}
                                />
                            </div>
                        </div>}
                    </>:<>
                        {(result?.data?.total_count===0 && result?.data?.success_status===true && searchParams.get("search")) ?
                            <SearchEmptyScreen text={"No exact matches found. Please try a different search"} monitorPatientList={true} />
                            :
                            result?.data?.total_count===0&&!searchParams.get("search")?<Emptyscreen
                                title={"Manage Organizations"}
                                FirstPTag={isCorp===undefined?"No monitor users to view yet":'No corporate users to view yet'}
                                organizationUser={true}
                            />:((result?.status==="rejected"||(result?.data?.total_count!==0&&result?.data?.data?.length===0))&&<SearchEmptyScreen text={"No data found"} />)
                        }
                    </>}

                </div>
                }
            </div>}
            {isAdvancedSearchOpen&&searchParams?.get('limit')&&!searchParams.get('view')&&
            <PatiantAdvancedSearch                    
                handleOnSubmit={handleOnSubmit}
                emptyField={emptyField}
                setEmptyField={setEmptyField}
                orgCorpAndMonitorSearch={true}
            />
            }
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
    )
}
